import styled from 'styled-components';

const VBucksBody = styled.p`
  color: #fff;
  text-align: center;
  line-height: 1;
  font-size: 1em !important;
`;

export default VBucksBody;
